import { Action, createReducer, on } from '@ngrx/store';

import {
    errorGetGeneralData,
    errorGetGeneralDataById,
    errorGetMovements,
    getGeneralData,
    getGeneralDataById,
    getGeneralDataByIdClear,
    getGeneralDataClear,
    getMovements,
    getMovementsClear,
    successGetGeneralData,
    successGetGeneralDataById,
    successGetMovements
} from '../actions';
import { DEFAULT_DATA, IMovimiento, IRCCPGeneralData, TPilar } from './../../shared/models/recompepsi.interface';


/**
 * * Obtiene datos generales del programa de lealtad
 */
export interface GeneralDataState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IRCCPGeneralData;
}

export const GeneralDataInit: GeneralDataState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: DEFAULT_DATA,
};

const _generalDataReducer = createReducer(
    GeneralDataInit,
    on(getGeneralData, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successGetGeneralData, (state, data) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorGetGeneralData, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(getGeneralDataClear, state => ({ ...state, ...GeneralDataInit }))
);

export function GeneralDataReducer(state: GeneralDataState, action: Action) {
    return _generalDataReducer(state, action);
}

/**
 * * Obtiene datos generales del programa de lealtad por id
 */
export interface GeneralDataByIdState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: TPilar;
}

export const GeneralDataByIdInit: GeneralDataByIdState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as TPilar,
};

const _generalDataByIdReducer = createReducer(
    GeneralDataByIdInit,
    on(getGeneralDataById, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successGetGeneralDataById, (state, data) => (
        {
            ...state,
            loading: false,
            success: true,
            data: data.puntos ?? data.compra ?? data.reto ?? data.autoevaluacion ?? data.portafolio,
        }
    )),
    on(errorGetGeneralDataById, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(getGeneralDataByIdClear, state => ({ ...state, ...GeneralDataByIdInit }))
);

export function GeneralDataByIdReducer(state: GeneralDataByIdState, action: Action) {
    return _generalDataByIdReducer(state, action);
}


/**
 * * Obtiene movimientos del programa de lealtad
 */
export interface MovementsState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IMovimiento[];
}

export const MovementsInit: MovementsState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: [],
};

const _movementsReducer = createReducer(
    MovementsInit,
    on(getMovements, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successGetMovements, (state, { movimientos }) => (
        {
            ...state,
            loading: false,
            success: true,
            data: movimientos,
        }
    )),
    on(errorGetMovements, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(getMovementsClear, state => ({ ...state, ...MovementsInit }))
);

export function MovementsReducer(state: MovementsState, action: Action) {
    return _movementsReducer(state, action);
}
